import { render } from "./TextareaAutosize.vue?vue&type=template&id=31a60000"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\haqua\\Documents\\vue\\rebrand\\feedback-page-resell\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__